// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3I4SN","header":"PatientBlock_header__2i3Ml","label":"PatientBlock_label__1G7ju","option":"PatientBlock_option__D_0R0"};